import { array } from "prop-types";
import React, {ReactDOM} from "react";
import Webcam from "react-webcam";
import Modal from "react-modal";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const videoStyle = {
  width: "100%",
  border: "2px solid #ccc" 
};

const kycVideoContainer = {
  width: "40%",
  margin: "0 auto",
  position:"relative"
}

const WebcamCapture = (props) => {
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [captureTime, setCaptureTime] = React.useState(0);
  const [captureTimer, setCaptureTimer] = React.useState(null);


  const [getVideo, setGetVideo] = React.useState("");
  const [isPreviewModelOpen, setIsPreviewModelOpen] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);

  React.useEffect(() => {
    return () => {
      if (captureTimer) {
        clearInterval(captureTimer);
      }
    };
  }, [captureTimer]);

  const handleStartCaptureClick = React.useCallback(() => {
    if (captureTime >= 60) {
      alert("Previous recording exceeded 60 seconds. Please start a new recording.");
      return;
    }
    
    setRecordedChunks([]);
    setGetVideo("");
    setCaptureTime(0);
    setCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/mp4"
    });
    mediaRecorderRef.current.addEventListener(
      "dataavailable",
      handleDataAvailable
    );
    mediaRecorderRef.current.start();
    
    const timer = setInterval(() => {
      setCaptureTime(prevTime => {
        const newTime = prevTime + 1;
        if (newTime >= 60) {
          handleStopCaptureClick();
          return 60;
        }
        return newTime;
      });
    }, 1000);
    setCaptureTimer(timer);
  }, [webcamRef, setCapturing, mediaRecorderRef, captureTime]);

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStopCaptureClick = React.useCallback(() => {
    mediaRecorderRef.current.stop();
    setCapturing(false);
    
    if (captureTimer) {
      clearInterval(captureTimer);
      setCaptureTimer(null);
    }
  }, [mediaRecorderRef, webcamRef, setCapturing, captureTimer]);

  const handleDownload = React.useCallback(() => {
    if (recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/mp4"
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = "react-webcam-stream-capture.mp4";
      a.click();
      window.URL.revokeObjectURL(url);
      setRecordedChunks([]);
    }
  }, [recordedChunks]);

  const previewVideo = React.useCallback(() => {

    if (recordedChunks.length) {

      const blob = new Blob(recordedChunks, {
        type: "video/mp4"
      });
      const url = URL.createObjectURL(blob);



      setGetVideo(url);
      setIsPreviewModelOpen(true);

      
    }
  }, [recordedChunks]);

  // Uploads the recorded video to the server for KYC verification with captcha code
  const handleViewUrl = React.useCallback(() => {
    if (recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/mp4"
      });

      const timestamp = new Date().getTime();
      const fileName = `kyc_video_${timestamp}.mp4`;
      
      const file = new File([blob], fileName, {
        type: "video/mp4"
      });

      const form = new FormData();
      form.append('file', file, 'video.mp4');
      form.append('captcha_code', props.captcha);

      setUploading(true);

      profileUpdateService
        .kycVideoUpload(form)
        .then((response) => {
          if (response.status === 200 || response.status === "200") {
            toast.success(response.message || 'Video uploaded successfully', {
              position: "top-right",
              autoClose: 3000,
            });            
           
            
            let userVideoAndCaptcha = [blob, props.captcha];
            if (props.getFile) {
              props.getFile(userVideoAndCaptcha);
            }
          } else {
            toast.error(response.message || 'Failed to upload video', {
              position: "top-right",
              autoClose: 5000,
            });
          }
        })
        .catch((error) => {
          console.error('Error uploading video:', error);
          toast.error('Failed to upload video. Please try again.', {
            position: "top-right",
            autoClose: 5000,
          });
        })
        .finally(() => {
          setUploading(false);
          setRecordedChunks([]);
        });
    }
  }, [recordedChunks, props]);




  const noCamera = React.useCallback(() => {
    alert('Please provide permission to access webcam')
    props.isCamera("nocamera");
  }, []);


  let closePreviewModelOpen = () => {
    setIsPreviewModelOpen(false);
  };

  const resetCapture = React.useCallback(() => {
    setRecordedChunks([]);
    setGetVideo("");
    setCaptureTime(0);
    setCapturing(false);
    if (captureTimer) {
      clearInterval(captureTimer);
      setCaptureTimer(null);
    }
  }, [captureTimer]);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%",
      background: "transparent",
    },
    overlay: { zIndex: 1000 },
  };

  const videoPreviewWrapper = {
    position: "relative",
    paddingBottom: "56.25%",
    height: "0"
  };


  const videoWrapper = {
    position: "relative",
    paddingBottom: "56.25%",
    height: "0"
  };

  
  return (
    <div className="post-new-job" style={{textAlign:"center"}}>
      <div style={kycVideoContainer}>
        <Webcam audio={true} muted onUserMediaError={noCamera} ref={webcamRef} style={videoStyle} />
        <div className="kyc-captcha" style={{position: "absolute", zIndex : "111", width:"100%", bottom:"6%"}}>
          <div style={{padding:"10px", background:"rgba(0,0,0,.5)", display: "inline-block", color: "#fff"}}>
            <p style={{margin:"0", color: "#fff"}}>READ THE WORDS</p>
            <p style={{margin:"0", color: "#ccc"}}>I am {props.uname}</p>
            {props.captcha}
          </div>
        </div>
      </div>

      {capturing ? (
        <div>
          <button onClick={handleStopCaptureClick}>Stop Capture</button>
          {captureTime > 30 && <div style={{marginTop: "10px", fontSize: "16px", fontWeight: "bold", color: captureTime >= 50 ? "#ff4444" : "#333"}}>
            Time: {captureTime}s / 60s
            {captureTime >= 50 && <div style={{color: "#ff4444", fontSize: "14px"}}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Recording will auto-stop soon!</div>}
          </div>}
        </div>
      ) : (
        <button onClick={handleStartCaptureClick}>Start Capture</button>
      )}

        <br/>       
      
      {recordedChunks.length > 0 && (
        <>  
        <br/> 
        <button onClick={previewVideo} disabled={uploading}>Preview</button>&nbsp;
        <button onClick={handleViewUrl} disabled={uploading}>
          {uploading ? 'Uploading...' : 'Upload'}
        </button>&nbsp;
        <button onClick={resetCapture} disabled={uploading} style={{backgroundColor: "#ff4444", color: "white"}}>Reset</button>
        </>
      )}


      <Modal
          isOpen={isPreviewModelOpen}
          onRequestClose={closePreviewModelOpen}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Preview</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePreviewModelOpen}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                  <div className="videoWrapper" style={videoWrapper}>
                      <video src={getVideo} controls width="100%">
                        Sorry, your browser doesn't support videos.
                      </video>
                  </div>  
              </div>
            </div>
          </div>
        </Modal>



    </div>
  );
};

export default WebcamCapture;